import styled from 'styled-components';

const ImgHomePages = styled.img`
  position: relative;
  width: 100%;
  height: 725px;
`;

const ContainerImg = styled.img`
  width: 100%;
`;
const ContainerImgText = styled.img`
  width: 100%;
  height: 725px;
`;

const ContainerImgOne = styled.img`
  width: 40%;
  height: 40%;
`;

const TitleHowItsWork = styled.div`
  /* Header */

  font-family: 'Ubuntu';
  font-style: normal;
  font-weight: 700;
  font-size: 45px;
  line-height: 52px;
  /* identical to box height */

  text-align: center;

  color: #ee7b57;
`;

export { ImgHomePages, ContainerImg, TitleHowItsWork, ContainerImgOne, ContainerImgText };
